const TC = "TAXES/CONCEPT";

export const LOAD_ARTICLES = `${TC}/LOAD_ARTICLES`;
export const GENERATE_TOTAL = `${TC}/GENERATE_TOTAL`;
export const SELECTED_ITEM = `${TC}/SELECTED_ITEM`;
export const LOAD_TOTAL = `${TC}/LOAD_TOTAL`;
export const LOAD_SUB_TOTAL = `${TC}/LOAD_SUB_TOTAL`;
export const LOAD_PAYMENT_REQUEST = `${TC}/LOAD_PAYMENT_REQUEST`;
export const LOAD_CAPTCHA = `${TC}/LOAD_CAPTCHA`;
export const LOAD_INTERNAL_ID = `${TC}/LOAD_INTERNAL_ID`;
export const RESET_STORE = `${TC}/RESET_STORE`;
